import React, { AriaRole } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { IconLanguageOutline } from '@saucelabs/ds-icons';
import { actions as modalActions } from '@saucelabs/sl-container-modal';

import { TOOLBAR_TRACKING_NAMES, trackEvent } from '../../../tracking';
import ChangeLanguageModal from '../../../components/MobileManualSession/ChangeLanguageModal';
import selectors from '../selectors';
import GenericButton from './GenericButton';

const LanguageButton: React.FC<{ role?: AriaRole }> = ({ role }) => {
  const dispatch = useDispatch<ReduxDispatcher>();
  const {
    deviceToolsDisabled,
    deviceType,
    testType,
  } = useSelector(selectors.toolbarButtonSelector);

  const showLanguageModal = () => {
    void dispatch(modalActions.showModal('changeLanguageModal'));

    trackEvent(TOOLBAR_TRACKING_NAMES.LANGUAGE, { deviceType, testType });
  };

  return (
    <>
      <ChangeLanguageModal />

      <GenericButton
        dataQa="live-session-toolbar-button-language"
        disabled={deviceToolsDisabled}
        icon={IconLanguageOutline}
        label="Language"
        onPress={showLanguageModal}
        role={role}
      />
    </>
  );
};

LanguageButton.displayName = 'LanguageButton';

export default LanguageButton;
